import { Component, OnInit } from '@angular/core'
import { BuildingAllocationRow } from '@parkupp/core'
import { ParkingInsightsService } from '../../../services/parking-insights.service'
@Component({ selector: 'app-admin-building-allocations', templateUrl: './admin-building-allocations.component.html', styleUrls: ['../../../shared/insights/insights.scss'] })
export class AdminBuildingAllocationsComponent implements OnInit {
    rows: BuildingAllocationRow[] = []
    private savedConfirmed = new Map<string, boolean>()
    search = ''
    status = 'pending'
    loading = true
    refreshing = false
    saving = new Set<string>()
    error = ''
    message = ''
    constructor(private insights: ParkingInsightsService) {}
    ngOnInit() {
        this.load()
    }
    get filtered() {
        const term = this.search.trim().toLowerCase()
        return this.rows.filter(
            (r) =>
                (this.status === 'all' || (this.status === 'pending' ? !this.savedConfirmed.get(r.parkingKey) : this.savedConfirmed.get(r.parkingKey))) &&
                `${r.title} ${r.merchantName} ${r.city} ${r.suburb} ${r.enterpriseKey}`.toLowerCase().includes(term)
        )
    }
    async load() {
        this.loading = true
        this.error = ''
        try {
            this.rows = await this.insights.allocations()
            this.savedConfirmed = new Map(this.rows.map((r) => [r.parkingKey, r.confirmed]))
        } catch {
            this.error = 'Could not load building allocations. Please retry.'
        } finally {
            this.loading = false
        }
    }
    async save(row: BuildingAllocationRow) {
        this.saving.add(row.parkingKey)
        this.error = ''
        this.message = ''
        try {
            await this.insights.saveAllocation(row)
            this.savedConfirmed.set(row.parkingKey, row.confirmed)
            this.message = `Saved ${row.title}. Refresh insights to publish the updated grouping.`
        } catch {
            this.error = `Could not save ${row.title}. Enter a city and suburb and try again.`
        } finally {
            this.saving.delete(row.parkingKey)
        }
    }
    async refresh() {
        this.refreshing = true
        this.error = ''
        this.message = ''
        try {
            await this.insights.refresh()
            this.message = 'Public and landlord insights refreshed successfully.'
        } catch {
            this.error = 'Could not refresh insights. Saved allocations are retained; please try again.'
        } finally {
            this.refreshing = false
        }
    }
}
